import React, { createContext, useContext, useState, useEffect } from 'react';


const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [packageType, setPackageType] = useState('basic');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is already logged in
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const userData = JSON.parse(storedUser);
      setUser(userData);
      setPackageType(userData.package_type || 'basic');
    }
    setLoading(false);
  }, []);

  const login = (userData) => {
    setUser(userData);
    setPackageType(userData.package_type || 'basic');
    localStorage.setItem('user', JSON.stringify(userData));
  };

  // const logout = () => {
  //   setUser(null);
  //   setPackageType('basic');
  //   localStorage.removeItem('user');
  //   // Add any additional cleanup or API calls for logout
  // };

  const logout = () => {
  setUser(null);
  setPackageType('basic');

  localStorage.removeItem('user');

  // Reset page view tracking
  sessionStorage.removeItem(
    "page_view_tracked"
  );

  // Optional analytics cleanup
  localStorage.removeItem(
    "analytics_data"
  );
};

  const isPremium = packageType === 'advance';

  return (
    <AuthContext.Provider value={{ 
      user, 
      packageType, 
      isPremium, 
      login, 
      logout, 
      loading 
    }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};